module.exports = __webpack_public_path__ + "static/media/fp-icon-light.e42e3ef0.svg";